import Date from '../../../../Core/Fields/Floating/Date';
import { useState } from 'react';
import Input from '../../../../Core/Fields/Floating/Input';
import Textarea from '../../../../Core/Fields/Floating/Textarea';
import SelectSearch from '../../../../Core/Fields/Floating/SelectSearch';
import GetIcon from '../../../../utils/Icon';
import VersionHistory from '../../../../utils/VersionHistory';
const Tab1 = ({ vendor,realponumber, required_date, selectedAddress, podate, ponumber, activityboll, pTerms, termandcondition, taxandchanges, cost_center, project, currency, price,setasn_inclusion,asn_inclusion }) => {
  const [showActivity, setShowActivity] = useState(true);
  
  return (
    <div
      className="row sidebarbox m-0 d-flex flex-column"
      style={{ flexWrap: 'nowrap', padding: "8px", borderRadius: "5px", height: "72vh", overflowY: "scroll" }}
    >
      <div className="col-12">
        <div className='mb-3'>
            <Input id="orderNo" label="No." value={realponumber} readOnly={true} style={{ height: '30px' }} />
        </div>
        </div>

      <div className="col-12 ">
        <div className={vendor.Error ? `mb-3 errorborder` : `mb-3`}>
          {ponumber ? <Input
            id="orderNo"
            label="Select Supplier"
            readOnly
            value={vendor.select_vendor}
            style={{ height: '30px' }}
          /> : <SelectSearch
            list={vendor.vendor_list}
            label="Select Supplier"
            getOptionLabel={(item) => item.name}
            getOptionValue={(item) => item.name}
            value={vendor.select_vendor}
            onChange={(val) => vendor.setselect_vendor(val)}
          />}

        </div>
      </div>
      <div className="col-12">
        <div className="mb-3">
          <Textarea
            id="ponumber"
            label="Supplier Address"
            value={
              selectedAddress.currentAddress?.name
                ? `${selectedAddress.currentAddress?.address_line1}, ${selectedAddress.currentAddress?.address_line2},\n ${selectedAddress.currentAddress?.city}, ${selectedAddress.currentAddress?.state} ${selectedAddress.currentAddress?.country} - ${selectedAddress.currentAddress?.pincode}`
                : ''
            }
            readOnly={true}

            style={{
              whiteSpace: 'pre-wrap',
              border: selectedAddress.Error ? '1px solid red' : ''
            }}
          />
        </div>

      </div>
      <div className="col-12 ">
        <div className="mb-3 " >
          {ponumber ? <Input
            id="orderNo"
            label="Posting Date"
            readOnly
            value={required_date.required_date}
            style={{ height: '30px' }}
          /> : <Date
            id="requireddata"
            label="Posting Date"
            value={required_date.required_date}
            onChange={(e) => required_date.setrequired_date(e.target.value)}
            error={required_date.Error}
            min={true}
          />}
        </div>
      </div>
      <div >

        <div className="col-12">
          <div className="py-2 d-flex justify-content-between align-items-center" onClick={() => setShowActivity(!showActivity)}>
            <p className="firstcolor m-0">
              Activity
            </p>
            <GetIcon
              iconName={showActivity ? "MdKeyboardArrowUp" : "MdKeyboardArrowDown"}
              size={22}
            />
          </div>

          {showActivity && (
            <VersionHistory doctype="Purchase Order" docname={ponumber} activityboll={activityboll} />

          )}
        </div>


      </div>
    </div>
  )
}

export default Tab1